export var QrCodeUtil;
(function (QrCodeUtil) {
    let Type;
    (function (Type) {
        Type.Google = 10; // 2024/01/15 サービスが停止されている様子。今後復旧するか不明
        Type.GoQrMe = 20;
        Type.Default = Type.GoQrMe;
    })(Type = QrCodeUtil.Type || (QrCodeUtil.Type = {}));
    function createImageUrl(value, size, type = Type.Default) {
        if (value == null) {
            return null;
        }
        const url = encodeURIComponent(value);
        const sizeWH = `${size}x${size}`;
        switch (type) {
            case Type.Google:
                return `https://chart.apis.google.com/chart?chs=${sizeWH}&cht=qr&chl=${url}`;
            case Type.GoQrMe:
                return `https://api.qrserver.com/v1/create-qr-code/?size=${sizeWH}&data=${url}`;
        }
    }
    QrCodeUtil.createImageUrl = createImageUrl;
})(QrCodeUtil || (QrCodeUtil = {}));
